import React, { useState } from "react";

// import JS files
import MuiButton from "../../shares/MuiButton";
import AddOrderModal from "./AddOrderModal";
import MuiModal from "../../shares/MuiModal";
import RingsSizeShow from "../../shares/RingsSizeShow";
// import Others files
import sampleImg from "../../../imgs/sample-ring.png";

const RingCard = (props) => {
  let windowWidth = window.screen.width;

  const [openRingsSizeShowModal, setOpenRingsSizeShowModal] = useState(false);
  const handleRingsSizeShowModal = () => {
    setOpenRingsSizeShowModal((before) => !before);
  };

  const [openAddOrderModal, setOpenAddOrderModal] = useState(false);
  const handleAddOrderModal = () => {
    setOpenAddOrderModal((before) => !before);
  };

  return (
    <>
      {openRingsSizeShowModal && (
        <MuiModal
          openModal={openRingsSizeShowModal}
          setOpenModal={setOpenRingsSizeShowModal}
          width="w-3/5"
        >
          <RingsSizeShow
            w1={props.item.size_one_weight}
            w2={props.item.size_two_weight}
            w3={props.item.size_three_weight}
            w4={props.item.size_four_weight}
            w5={props.item.size_five_weight}
            w6={props.item.size_six_weight}
            code={props.item.code}
            show_name={props.item.show_name}
            brand={props.item.brand_name}
            gender={props.item.gender}
            color={props.item.color}
          />
        </MuiModal>
      )}
      {openAddOrderModal && (
        <AddOrderModal
          producerCreateOrder={props.producerCreateOrder}
          item={props.item}
          openModal={openAddOrderModal}
          setOpenModal={setOpenAddOrderModal}
        />
      )}
      <div className="panel-card">
        <div className="absolute bg-slate-100 rounded-lg py-1 px-4">
          <span className="text-xs md:text-sm">{props.type}</span>
        </div>
        {props.item.color == "yellow" ? (
          <div className="absolute bg-yellow-400 rounded-md py-1 px-4	left-4">
            <span className="text-xs md:text-sm">زرد</span>
          </div>
        ) : (
          <div className="absolute bg-Indigo-50 border border-slate-200 rounded-md py-1 px-4	left-4">
            <span className="text-xs md:text-sm">سفید</span>
          </div>
        )}

        <div className="flex justify-center mb-8">
          {props.item.attach_file == "EMPTY" ? (
            <img
              className="w-20 h-20 md:w-32 md:h-32 rounded-full"
              src={sampleImg}
            />
          ) : (
            <img
              className="w-28 h-28 md:w-32 md:h-32 rounded-full"
              src={props.item.attach_file}
            />
          )}
        </div>
        <div className="flex items-center justify-between">
          <span className="show-label	">
            کد: <span className="show-value	"> {props.item.code}</span>
          </span>
          <span className="show-label">
            اسم: <span className="show-value"> {props.item.show_name}</span>
          </span>
          <span className="show-label">
            برند: <span className="show-value	"> {props.item.brand_name}</span>
          </span>
        </div>
        <div className="flex items-center justify-between mt-6">
          <MuiButton
            onClick={handleRingsSizeShowModal}
            variant="outlined"
            color="primary"
            text="مشاهده وزن‌ها"
            size="small"
          />
          <MuiButton
            onClick={handleAddOrderModal}
            variant="outlined"
            color="secondary"
            text="افزودن"
            size="small"
          />
        </div>
      </div>
    </>
  );
};

export default RingCard;
